import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "../Box";
import { DropdownMenuItemType } from "../DropdownMenu/types";
import MenuItem from "../MenuItem/MenuItem";
import { OpenNewIcon } from "../Svg";
import StyledSubMenuItems from "./styles";
var SubMenuItems = function(_param) {
    var _items = _param.items, items = _items === void 0 ? [] : _items, activeItem = _param.activeItem, _isMobileOnly = _param.isMobileOnly, isMobileOnly = _isMobileOnly === void 0 ? false : _isMobileOnly, props = _object_without_properties(_param, [
        "items",
        "activeItem",
        "isMobileOnly"
    ]);
    return /*#__PURE__*/ _jsx(StyledSubMenuItems, _object_spread_props(_object_spread({
        justifyContent: [
            isMobileOnly ? "flex-end" : "start",
            null,
            "center"
        ]
    }, props), {
        pl: [
            "12px",
            null,
            "0px"
        ],
        $isMobileOnly: isMobileOnly,
        children: items.map(function(param) {
            var label = param.label, href = param.href, icon = param.icon, itemProps = param.itemProps, type = param.type;
            var Icon = icon;
            var isExternalLink = type === DropdownMenuItemType.EXTERNAL_LINK;
            var linkProps = isExternalLink ? {
                as: "a",
                target: "_blank"
            } : {};
            return label && /*#__PURE__*/ _jsx(Box, {
                mr: "20px",
                children: /*#__PURE__*/ _jsxs(MenuItem, _object_spread_props(_object_spread({
                    href: href,
                    isActive: href === activeItem,
                    variant: "subMenu"
                }, itemProps, linkProps), {
                    children: [
                        Icon && /*#__PURE__*/ _jsx(Icon, {
                            color: href === activeItem ? "secondary" : "textSubtle",
                            mr: "4px"
                        }),
                        label,
                        isExternalLink && /*#__PURE__*/ _jsx(Box, {
                            display: [
                                "none",
                                null,
                                "flex"
                            ],
                            style: {
                                alignItems: "center"
                            },
                            ml: "4px",
                            children: /*#__PURE__*/ _jsx(OpenNewIcon, {
                                color: "textSubtle"
                            })
                        })
                    ]
                }))
            }, label);
        })
    }));
};
export default SubMenuItems;
